var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipmentTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H4.88283",
    stroke: "#2E77D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0869141 3.87748H3.44386V3.79028",
    stroke: "#2E77D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0869141 6.66772H2.00517",
    stroke: "#2E77D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58301 1H15.4331V11.5068",
    stroke: "#2E77D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5205 4.40039L19.139 5.6211C19.5314 5.75189 20.3161 6.22273 20.3161 7.05979V14.3404H18.9211",
    stroke: "#2E77D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5205 9.3269H18.6159",
    stroke: "#2E77D0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.741211 9.02173V14.2969H2.04911",
    stroke: "#2E77D0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80371 14.3843H11.8146",
    stroke: "#2E77D0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.0132,
    cy: 14.2534,
    r: 2.24659,
    stroke: "#2E77D0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0874,
    cy: 14.2534,
    r: 2.24659,
    stroke: "#2E77D0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.6L7.125 8L12 4",
    stroke: "#2E77D0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentTruck);
export default __webpack_public_path__ + "static/media/shipmentTruck.d06ac3f7a91d70e8073eb406abb7acf8.svg";
export { ForwardRef as ReactComponent };